import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import { Divider, Avatar, Modal, Typography, Collapse } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import axios from "axios";
import { error } from "../../Controllers/toast";

const { Paragraph } = Typography;
const { Panel } = Collapse;

const FatoryDetail = ({
  fact_name,
  fact_address,
  fact_power_name,
  fact_power_unit,
  fact_city,
  setTemp,
}) => {
  const [temp, setTempState] = useState(0);
  const lang_choiced = useSelector((state) => state.lang_change);

  useEffect(() => {
    if (temp === 0) {
      axios
        .get(
          `https://api.openweathermap.org/data/2.5/weather?q=${fact_city}&appid=62ceff27ff870c1657159272191847fa`
        )
        .then((res) => {
          // console.log("TEMPERETURE:",res.data)
          setTemp(parseInt(res.data.main.temp));
          setTempState(parseInt(res.data.main.temp));
        })
        .catch((err) => {
          // error("مشکلی در دریافت اطلاعات آب و هوایی رخ داده است!");
          console.log(err);
        });
    }
  });

  return (
    <Card className="border-radius-15 " style={{ height: "auto" }}>
      {/* <CardBody> */}
        <Collapse  ghost>
          <Panel showArrow={true}  header={<h5 className="text-right">{fact_name}</h5>} key="1">
            <Row>
              <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                {/* <p>
      <b>
        {lang_choiced.components.dashboard.factory_details.content.name}{" "}
        :
      </b>
      {fact_name}
    </p> */}

                <div className="mt-2">
                  <b>
                    {
                      lang_choiced.pages.dashboard.factoryDetail.fact_address
                    }{" "}
                    :{" "}
                  </b>
                  <Paragraph
                    ellipsis={{
                      rows: 2,
                      expandable: true,
                      symbol: "...",
                    }}
                  >
                    {fact_address}
                  </Paragraph>
                </div>

                <div>
                  <b>
                    {
                      lang_choiced.pages.dashboard.factoryDetail.fact_capacity
                    }{" "}
                    :{" "}
                  </b>
                  {fact_power_name}
                  {fact_power_unit}
                </div>
              </Col>
              {/* <div
    className="xs-hide"
    style={{
      padding: "0",
      width: "3px",
      marginRight: "2px",
      marginLeft: "2px",
    }}
  > */}
              {/* <Divider type="vertical" style={{ margin: "0", height: "100%" }} />
  </div>
  <Col
    className="xs-hide"
    sm={3}
    md={3}
    lg={3}
    xl={3}
    style={{ padding: "0" }}
  >
    <Avatar
      shape="square"
      size={124}
      // src={"/solar-panel-login.jpg"}
      style={{ width: "100%" }}
    />
  </Col> */}
            </Row>
          </Panel>
        </Collapse>
        {/* <Divider className="font-xl"> */}
        {/* <h5 className="text-center">
          
        </h5> */}
        {/* </Divider> */}
      {/* </CardBody> */}
    </Card>
  );
};

export default FatoryDetail;
